module.exports = __webpack_public_path__ + "static/isid-a680880ba2c8514ea97ad32706bbfa3b.png";